export const TEXTS = {
    CONNECTION_ERROR: "CONNECTION ERROR",
    ABORT_ERROR: "ABORT ERROR",
    NETWORK_CONNECTIVITY_RETRY_MSG: "Please check your network connectivity and try again",
    ABORTED_REQUEST_ERROR_MSG: "The request could not be processed completely, please check your network and try again",
    OOPS_SOMETHING_WENT_WRONG: "Oops Something went wrong!!",
};
